import { initContract } from '@ts-rest/core'
import { z } from 'zod'
import { ErrorResponseSchema } from '../../shared/types'
import {
  BindReactivationRedemptionTargetBodySchema,
  BindReactivationRedemptionTargetResponseSchema,
  BulkEnrollReactivationCampaignBodySchema,
  BulkEnrollReactivationCampaignResponseSchema,
  ClaimReactivationRedemptionResponseSchema,
  CompleteReactivationRedemptionResponseSchema,
  CreateReactivationCampaignBodySchema,
  ReactivationCampaignEligibilitySchema,
  ReactivationCampaignSchema,
} from './reactivation-campaign.schemas'

const c = initContract()

const options = {
  pathPrefix: '/reactivation-campaigns',
  commonResponses: {
    400: ErrorResponseSchema,
    404: ErrorResponseSchema,
    409: ErrorResponseSchema,
    500: ErrorResponseSchema,
  },
}

export const reactivationCampaignServiceContract = c.router({
  createReactivationCampaign: {
    method: 'POST',
    path: '',
    body: CreateReactivationCampaignBodySchema,
    responses: {
      200: ReactivationCampaignSchema,
    },
  },
  bulkEnrollReactivationCampaign: {
    method: 'POST',
    path: '/:campaignKey/enrollments/bulk',
    pathParams: z.object({ campaignKey: z.string().min(1).max(128) }),
    body: BulkEnrollReactivationCampaignBodySchema,
    responses: {
      200: BulkEnrollReactivationCampaignResponseSchema,
    },
  },
  evaluateReactivationCampaignEligibility: {
    method: 'GET',
    path: '/eligibility/:userId',
    pathParams: z.object({ userId: z.string().uuid() }),
    query: z.object({
      campaignKey: z.string().min(1).max(128),
    }),
    responses: {
      200: ReactivationCampaignEligibilitySchema,
    },
  },
  /** Finds the user's enrolled campaign (if any) and evaluates eligibility — no campaign key required. */
  resolveReactivationCampaignEligibility: {
    method: 'GET',
    path: '/eligibility/:userId/resolve',
    pathParams: z.object({ userId: z.string().uuid() }),
    responses: {
      200: ReactivationCampaignEligibilitySchema,
    },
  },
  claimReactivationRedemption: {
    method: 'POST',
    path: '/enrollments/:enrollmentId/claim-redemption',
    pathParams: z.object({ enrollmentId: z.string().uuid() }),
    body: null,
    responses: {
      200: ClaimReactivationRedemptionResponseSchema,
    },
  },
  bindReactivationRedemptionTarget: {
    method: 'PATCH',
    path: '/enrollments/:enrollmentId/redemption-target',
    pathParams: z.object({ enrollmentId: z.string().uuid() }),
    body: BindReactivationRedemptionTargetBodySchema,
    responses: {
      200: BindReactivationRedemptionTargetResponseSchema,
    },
  },
  completeReactivationRedemption: {
    method: 'POST',
    path: '/enrollments/:enrollmentId/complete-redemption',
    pathParams: z.object({ enrollmentId: z.string().uuid() }),
    body: null,
    responses: {
      200: CompleteReactivationRedemptionResponseSchema,
    },
  },
}, options)
